import { UseMutationResult } from '@tanstack/react-query'

import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { changeInstallationOwner, ChangeInstallationOwnerParams } from '../api'

type ChangeInstallationOwnerVariables = Omit<ChangeInstallationOwnerParams, 'authFetch'>

interface UseChangeInstallationOwnerParams {
  onSuccess?: (vars: ChangeInstallationOwnerVariables) => void
  onError?: (error: Error, vars: ChangeInstallationOwnerVariables) => void
}

type UseChangeInstallationOwner = (
  data: UseChangeInstallationOwnerParams
) => UseMutationResult<void | null, unknown, ChangeInstallationOwnerVariables>

/**
 * Hook to change installation owner
 */
export const useChangeInstallationOwner: UseChangeInstallationOwner = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  const mutationResult = usePortalMutation({
    mutationFn: (vars: ChangeInstallationOwnerVariables) =>
      changeInstallationOwner({
        ...vars,
        authFetch,
      }),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (error, vars) => onError?.(error, vars),
  })

  return mutationResult
}
